import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PatientMedicalHistoryVersions from './PatientMedicalHistoryVersions';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patientId: string;
	medicalHistoryDocumentId: string;
}

const PatientMedicalHistoryVersionsModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.patientMedicalHistory.history'
			size={Size.FULLSCREEN}>
			<PatientMedicalHistoryVersions
				patientId={props.patientId}
				medicalHistoryDocumentId={props.medicalHistoryDocumentId}
			/>
		</BaseModal>
	);
};

export default PatientMedicalHistoryVersionsModal;
